var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.571 7.179a3.536 3.536 0 1 1 7.072 0 3.536 3.536 0 0 1-7.072 0ZM13.929 9.107a2.893 2.893 0 1 1 5.785 0 2.893 2.893 0 0 1-5.785 0ZM3 18.107a6.107 6.107 0 0 1 12.214 0v.105a.643.643 0 0 1-.312.54 11.201 11.201 0 0 1-5.795 1.605c-2.118 0-4.102-.586-5.795-1.605a.643.643 0 0 1-.311-.54L3 18.107ZM16.5 18.11l-.001.123c-.005.29-.075.57-.2.823a8.647 8.647 0 0 0 4.338-.866.643.643 0 0 0 .36-.551 4.179 4.179 0 0 0-5.963-3.952 7.36 7.36 0 0 1 1.466 4.42v.003Z",
    fill: "#0F172A"
  })));
};
export default SvgUsers;